<div class="card" style="border-radius: 10px">
  <div class="card-body">
    <div class="row text-left">
      <div class="col-sm-12">
        <div class="d-flex justify-content-between mb-0">
          <h1 class="text-bold-400" style="color: #4e7977">
            Clientes & Municípios
          </h1>
        </div>
      </div>
      <div class="col-sm-12">
        <p class="mb-2 mt-2" style="font-size: 20px">
          Visualize e gerencie todos os servidores públicos do seu município.
          Utilize a busca e os filtros para encontrar e atualizar informações de
          forma eficiente.
        </p>
      </div>
    </div>

    <form #servForm="ngForm" novalidate>
      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="nome" >Município</label>
              <fieldset class="form-group position-relative has-icon-right">
                <input
                  type="text"
                  id="nome"
                  class="form-control"
                  [(ngModel)]="filters.municipio"
                  name="municipio"
                  placeholder="Digite um nome próprio"
                  required
                  aria-invalid="false"
                />
                <div class="form-control-position">
                  <i class="ft-search"></i>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="cpf">Situação</label>
              <ng-select
                [items]="situacoesCadastrais"
                name="situacaoCadastral"
                bindLabel="label"
                bindValue="id"
                placeholder="Selecione a situação de Cadastro"
                id="situacaoCadastral"
                [(ngModel)]="filters.situacao"
              ></ng-select>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <label for="data_cadastro"
              >Data de cadastro</label
            >
            <div class="d-flex">
              <div class="input-group">
                <input
                  type="text"
                  id="data_cadastro"
                  class="form-control"
                  mask="00/00/0000"
                  [(ngModel)]="filters.periodoCadastroInicio"
                  name="data_cadastro"
                  placeholder="dd-mm-yyyy"
                  required
                  aria-invalid="false"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
              <span class="mx-2 d-flex align-items-center">até</span>
              <div class="input-group">
                <input
                  type="text"
                  id="data_nascimento"
                  class="form-control"
                  mask="00/00/0000"
                  [(ngModel)]="filters.periodoCadastroFim"
                  name="data_nascimento"
                  placeholder="dd-mm-yyyy"
                  required
                  aria-invalid="false"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col m-auto">
          <label
            class="ml-2"
            style="font-size: 16px; text-transform: math-auto; font-weight: 400"
          >
            <input
              type="checkbox"
              [(ngModel)]="filters.isCliente"
              name="isCliente"
            />
            Mostrar apenas os municípios cadastrados como clientes.
          </label>
        </div>
      </div>
    </form>
    <div class="form-row d-flex justify-content-end align-items-center">
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="clearFilters()"
        >
          Limpar filtros
        </button>
      </div>
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-outline-primary mb-2 mb-md-0"
          (click)="applyFilters()"
        >
          Pesquisar <i class="fa fa-search mr-1"></i>
        </button>
      </div>
    </div>
    <hr />
    <div class="form-row d-flex justify-content-end">
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-primary"
          (click)="openModalCadastroCliente(modalCadastroCliente)"
        >
          <i class="fa fa-plus mr-2"></i>Cadastrar Cliente
        </button>
      </div>
    </div>
  </div>
</div>

<div class="card" style="border-radius: 10px">
  <table class="table text-center table-striped" style="padding: 10px">
    <thead>
      <tr>
        <th (click)="sortTable('nome')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Município
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('nome')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('nome')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('nome')"
                class="fa"
                [ngClass]="getSortIcon('nome')"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('usuarios')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Usuários
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('usuarios')" class="fa fa-caret-up"></i>
              <i
                *ngIf="!isColumnSorted('usuarios')"
                class="fa fa-caret-down"
              ></i>
              <i
                *ngIf="isColumnSorted('usuarios')"
                class="fa"
                [ngClass]="getSortIcon('usuarios')"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('orgaos')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Órgãos
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('orgaos')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('orgaos')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('orgaos')"
                class="fa"
                [ngClass]="getSortIcon('orgaos')"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('status')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Status
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('status')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('status')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('status')"
                class="fa"
                [ngClass]="getSortIcon('status')"
              ></i>
            </div>
          </div>
        </th>
        <th>
          <div class="d-flex align-items-center justify-content-center"></div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let cidade of cidadesData">
        <td class="pl-3 pr-3 align-middle">
          <div
            class="d-flex align-items-center justify-content-center texto-linha-tabela"
          >
            {{ cidade.nome }}
          </div>
        </td>
        <td class="text-center align-middle texto-linha-tabela">
          {{ cidade.quantidade_usuarios }}
        </td>
        <td class="text-center align-middle texto-linha-tabela">
          {{ cidade.quantidade_orgaos }}
        </td>
        <td class="text-center align-middle">
          <span
            class="badge"
            [style.background-color]="getStatusColor(cidade)"
            [style.color]="'white'"
            style="font-size: 12px"
          >
            {{ getStatusCidade(cidade) }}
          </span>
        </td>
        <td class="d-flex justify-content-end align-items-center">
          <button
            type="button"
            (click)="goToDetails(cidade.id)"
            class="btn btn-outline-primary action-btn mr-1 btn-square"
          >
            <i class="fa fa-eye"></i>
          </button>
          <div class="dropdown btn-group mr-1" ngbDropdown>
            <button
              type="button"
              class="btn btn-outline-primary dropdown-toggle action-btn btn-retangle"
              ngbDropdownToggle
            >
              Acesso Rápido
            </button>
            <div
              ngbDropdownMenu
              class="dropdown-menu dropdown-brprev"
              role="menu"
            >
              <a
                class="dropdown-item dropdown-brprev"
                routerLink="/page/usuarios"
                [queryParams]="{ nomeCidade: cidade.nome }"
                ><i class="fa fa-users"></i> Usuários e Acessos</a
              >
              <a
                class="dropdown-item dropdown-brprev"
                routerLink="/page/importacoes"
                [queryParams]="{ idCidade: cidade.id }"
                ><i class="fa fa-upload"></i> Central de Importações</a
              >
              <a
                class="dropdown-item dropdown-brprev"
                routerLink="/page/sapiem"
                [queryParams]="{ cidade: cidade.id }"
                ><i class="fa fa-file-code-o"></i> SAPIEM</a
              >
              <a
                class="dropdown-item dropdown-brprev"
                routerLink="/page/servidores"
                [queryParams]="{ idCidade: cidade.id }"
                ><i class="fa fa-user"></i> Servidores Cadastrados</a
              >
              <a
                class="dropdown-item dropdown-brprev"
                routerLink="/page/municipio/relatorios"
                [queryParams]="{ idCidade: cidade.id }"
                ><i class="fa fa-file-text-o"></i> Relatórios</a
              >
              <a
                class="dropdown-item dropdown-brprev"
                routerLink="/page/municipio/orgaos"
                [queryParams]="{ idCidade: cidade.id }"
                ><i class="fa fa-cog"></i> Parametrização e Configurações</a
              >
              <a
                class="dropdown-item dropdown-brprev"
                routerLink="/page/municipio/usuarios"
                [queryParams]="{ nomeCidade: cidade.nome }"
                ><i class="fa fa-wifi"></i> Acesso Remoto</a
              >
              <a
                class="dropdown-item dropdown-brprev"
                routerLink="/page/permissoes"
                [queryParams]="{ nomeCidade: cidade.nome }"
                ><i class="fa fa-key"></i> Permissões e Acesso</a
              >
              <a
                class="dropdown-item dropdown-brprev"
                (click)="$event.preventDefault(); openModalDocumento(cadastroAnexo, cidade.id)"
                ><i class="fa fa-link"></i> Integração FlaxFlow</a
              >
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="form-row" *ngIf="cidadesTotal > 0" style="padding: 0px 20px">
    <div class="d-flex justify-content-between align-items-center w-100">
      <div>
         Exibindo {{(cidadesPage-1) * cidadesPageSize + 1}} a {{Math.min(cidadesPage * cidadesPageSize, cidadesTotal)}} de {{cidadesTotal}} itens
      </div>
      <div class="d-flex justify-content-center">
        <ngb-pagination
        class="ml-auto pagination-square"
        style="margin-top: 10px; margin-right: 10px"
        *ngIf="cidadesTotal > 0"
        [(page)]="cidadesPage"
        [pageSize]="cidadesPageSize"
        [maxSize]="3"
        [rotate]="true"
        [boundaryLinks]="true"
        size="sm"
        [collectionSize]="cidadesTotal"
        (pageChange)="onCidadesPageChange($event)"
      ></ngb-pagination>
      </div>
    </div>
  </div>


</div>

<ngx-spinner></ngx-spinner>

<!-- Modal de Cadastro de Cliente -->
<ng-template #modalCadastroCliente let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Novo Cliente</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form #clienteForm="ngForm" novalidate>
      <div class="row">
        <div class="col-12">
          <h5 class="mb-3">Informações Básicas</h5>
        </div>
      </div>

      <div class="form-row">
        <div class="col-12 col-md-3">
          <div class="form-group">
            <div class="controls">
              <label for="cep_cliente">CEP <b style="color: red">*</b></label>
              <input
                type="text"
                id="cep_cliente"
                class="form-control"
                [(ngModel)]="cliente.cep"
                mask="00.000-000"
                name="cep_cliente"
                placeholder="CEP"
                (change)="consultaCep()"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
        <div class="col-12 col-md-3">
          <div class="form-group">
            <div class="controls">
              <label for="estado_cliente"
                >Estado <b style="color: red">*</b></label
              >
              <ng-select
                [items]="estados"
                name="estado_cliente"
                (change)="toggleEstadoCliente()"
                bindLabel="estado"
                bindValue="estado"
                placeholder="Estado"
                id="estado_cliente"
                [(ngModel)]="cliente.estado"
              ></ng-select>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="form-group">
            <div class="controls">
              <label for="municipio_cliente"
                >Município <b style="color: red">*</b></label
              >
              <ng-select
                [items]="cidades"
                [disabled]="!cidades || cidades.length == 0"
                name="municipio_cliente"
                bindLabel="nome"
                bindValue="id"
                placeholder="Município"
                id="municipio_cliente"
                [(ngModel)]="cliente.municipio"
              ></ng-select>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="col-12 col-md-3">
          <div class="form-group">
            <div class="controls">
              <label for="tipo_logradouro_cliente">Tipo Logradouro</label>
              <ng-select
                [items]="tiposLogradouro"
                name="tipo_logradouro_cliente"
                bindLabel="descricao"
                bindValue="id"
                placeholder="Tipo Logradouro"
                id="tipo_logradouro_cliente"
                [(ngModel)]="cliente.tipo_logradouro"
              ></ng-select>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-9">
          <div class="form-group">
            <div class="controls">
              <label for="logradouro_cliente"
                >Logradouro <b style="color: red">*</b></label
              >
              <input
                type="text"
                id="logradouro_cliente"
                class="form-control"
                [(ngModel)]="cliente.logradouro"
                name="logradouro_cliente"
                placeholder="Logradouro"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <div class="controls">
              <label for="numero_cliente"
                >Número <b style="color: red">*</b></label
              >
              <input
                type="text"
                id="numero_cliente"
                class="form-control"
                [(ngModel)]="cliente.numero"
                name="numero_cliente"
                placeholder="Número"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="form-group">
            <div class="controls">
              <label for="complemento_cliente">Complemento</label>
              <input
                type="text"
                id="complemento_cliente"
                class="form-control"
                [(ngModel)]="cliente.complemento"
                name="complemento_cliente"
                placeholder="Complemento"
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-12">
          <div class="form-group">
            <div class="controls">
              <label for="bairro_cliente"
                >Bairro <b style="color: red">*</b></label
              >
              <input
                type="text"
                id="bairro_cliente"
                class="form-control"
                [(ngModel)]="cliente.bairro"
                name="bairro_cliente"
                placeholder="Bairro"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer justify-content-between">
    <button
      type="button"
      class="btn btn-outline-primary"
      (click)="modal.dismiss('Cancel')"
    >
      Voltar
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="cadastrarCliente(modal)"
      [disabled]="!isFormularioClienteValido()"
    >
      Cadastrar
    </button>
  </div>
</ng-template>

<!-- Modal de Cadastro de Anexo FlaxFlow -->
<ng-template #cadastroAnexo let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Novo Anexo</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="closeModal(modal)"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form #servForm="ngForm" novalidate>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <button
              type="button"
              class="btn btn-block btn-outline-primary"
              (click)="fileInput.click()"
            >
              <i class="fa fa-upload"></i> Carregar Documento
            </button>

            <!-- Input file oculto -->
            <input
              #fileInput
              type="file"
              (change)="selecionaArquivo($event)"
              class="d-none"
              accept=".xls,.xlsx,.docx,.pdf,.doc"
              multiple
            />
          </div>
        </div>

        <!-- Radios abaixo do botão -->
        <div class="col-md-12 mt-3">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="opcaoAnexo"
              id="processarEAnexar"
              [(ngModel)]="anexo.opcao"
              value="processarEAnexar"
            />
            <label class="form-check-label" for="processarEAnexar">
              Processar Documento e Anexar
            </label>
          </div>

          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="opcaoAnexo"
              id="anexar"
              [(ngModel)]="anexo.opcao"
              value="anexar"
            />
            <label class="form-check-label" for="anexar">Anexar</label>
          </div>

          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="opcaoAnexo"
              id="processar"
              [(ngModel)]="anexo.opcao"
              value="processar"
            />
            <label class="form-check-label" for="processar">
              Processar Documento
            </label>
          </div>
        </div>
      </div>

      <div *ngIf="statusEnvio" class="alert alert-info mt-3">
        {{ statusEnvio }}
      </div>

      <div class="modal-footer d-flex justify-content-between">
        <!-- Botão Voltar -->
        <button
          type="button"
          class="btn btn-outline-primary mt-3"
          (click)="closeModal(modal)"
        >
          Voltar
        </button>
        <!-- Botão Salvar -->
        <button
          type="button"
          class="btn btn-primary mt-3"
          (click)="cadastrarAnexo(modal)"
          [disabled]="!anexo.arquivos || anexo.arquivos.length === 0"
        >
          Adicionar
        </button>
      </div>
    </form>
  </div>
  <ngx-spinner></ngx-spinner>
</ng-template>
